import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardRightIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.5 20H8.5C8.22386 20 8 20.2239 8 20.5V21.5C8 21.7761 8.22386 22 8.5 22H23.5C23.7761 22 24 21.7761 24 21.5V20.5C24 20.2239 23.7761 20 23.5 20Z"
        fill={color}
      />
      <path
        d="M23.5 8H8.5C8.22386 8 8 8.22386 8 8.5V9.5C8 9.77614 8.22386 10 8.5 10H23.5C23.7761 10 24 9.77614 24 9.5V8.5C24 8.22386 23.7761 8 23.5 8Z"
        fill={color}
      />
      <path
        d="M23.5 2H0.5C0.223858 2 0 2.22386 0 2.5V3.5C0 3.77614 0.223858 4 0.5 4H23.5C23.7761 4 24 3.77614 24 3.5V2.5C24 2.22386 23.7761 2 23.5 2Z"
        fill={color}
      />
      <path
        d="M23.5 14H0.5C0.223858 14 0 14.2239 0 14.5V15.5C0 15.7761 0.223858 16 0.5 16H23.5C23.7761 16 24 15.7761 24 15.5V14.5C24 14.2239 23.7761 14 23.5 14Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardRightIcon.displayName = 'BoardRightIcon';
